import HackavizContest from "../../../../src/components/HackavizContest";
import * as React from 'react';
export default {
  HackavizContest,
  React
};